<template>
	<div class="sp-template">
		<div class="h-title">发票</div>
		<el-card class="box-card">
			<div slot="header" class="clearfix">
				<el-form :inline="true" :model="conditions" class="demo-form-inline" size="small">
          <el-form-item label="产品">
						<el-select v-model.lazy="conditions.product">
							<el-option v-for="(d, i) in customer" :key="i" :label="d.name" :value="d.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="订单号">
						<el-input v-model.lazy="conditions.number" placeholder="订单号"></el-input>
					</el-form-item>
          <el-form-item label="发票">
						<el-input v-model.lazy="conditions.number" placeholder="发票"></el-input>
					</el-form-item>
					<el-form-item label="开始日期">
						<el-date-picker v-model.lazy="conditions.startDate" type="date" value-format="yyyy-MM-dd" placeholder="开始日期"></el-date-picker>
					</el-form-item>
					<el-form-item label="结束日期">
						<el-date-picker v-model.lazy="conditions.endDate" type="date" value-format="yyyy-MM-dd" placeholder="结束日期"></el-date-picker>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="onSubmit">搜 索</el-button>
					</el-form-item>
				</el-form>
				<div>
					<el-button v-if="in_configs(40101)" size="small" class="btn-cyan">索要发票</el-button>
					<el-button v-if="in_configs(40102)" size="small" type="primary">生成账单</el-button>
				</div>
			</div>
			<el-table :data="tableData" stripe @selection-change="handleSelectionChange">
				<el-table-column type="selection" width="55"></el-table-column>
				<el-table-column prop="test" label="订单号"></el-table-column>
				<el-table-column prop="test" label="产品"></el-table-column>
				<el-table-column prop="test" label="发票号"></el-table-column>
				<el-table-column prop="test" label="货量"></el-table-column>
				<el-table-column prop="test" label="费用"></el-table-column>
				<el-table-column prop="test" label="发票生成时间"></el-table-column>
			</el-table>
			<!-- 分页 -->
			<el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[100, 200, 300, 400]" :page-size="100" layout="total, sizes, prev, pager, next, jumper" :total="400">
			</el-pagination>

			<!-- 表单 -->
			<el-dialog title="收货地址" :visible.sync="dialogTableVisible">
				<el-table :data="gridData">
					<el-table-column property="test" label="日期" width="150"></el-table-column>
				</el-table>
			</el-dialog>

			<!-- Form -->
			<el-dialog title="收货地址" :visible.sync="dialogFormVisible">
				<el-form :model="form" size="small">
					<el-form-item label="活动名称" :label-width="formLabelWidth">
						<el-input v-model.lazy="form.test"></el-input>
					</el-form-item>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button size="small" @click="dialogFormVisible = false">取 消</el-button>
					<el-button size="small" type="primary" @click="dialogFormVisible = false">确 定</el-button>
				</div>
			</el-dialog>
		</el-card>
	</div>
</template>

<script>
export default {
  data() {
    return {
      conditions: {
        product: "001",
        number: "",
        startDate: "",
        endDate: ""
      },
      customer: [{ name: "666", value: "001" }, { name: "777", value: "002" }],
      tableData: [{ test: "666" }],
      gridData: [{ test: "2016-05-02" }],
      dialogTableVisible: false,
      form: { test: "" },
      formLabelWidth: "120px",
      dialogFormVisible: false,
      multipleSelection: [],
      currentPage: 2 //分页
    };
  },
  components: {},
  created() {},
  computed: {},
  methods: {
    //搜索
    onSubmit() {
      console.log("搜索");
    },
    //多选按钮
    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log(this.multipleSelection);
    },
    //分页
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    }
  }
};
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/views/accountingcenter/invoice.vue